// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./new-theme.scss
// module id = ./new-theme.scss
// module chunks = 2